import React, { useState } from "react";

import {
  Box,
  Dialog,
  Grid2,
} from "@mui/material";
import { useLessonActions } from "../hooks/useLessonActions";
import ViewEditLesson from "./ViewEditLesson";
import ActionButtonsPane from "./ActionButtonsPane";
import ConfirmationDialog from "./ConfirmationDialog";

export default function EditLesson({
  open,
  onClose,
  onSave,
  users,
  scheduleRef,
  selectedLesson,
  setSelectedLesson,
  lessons,
  setChangedLesson,
  setLessons,
  role,
  onActionPerformed
}) {
  const [mode, setMode] = useState("view");
  const [confirmState, setConfirmState] = useState({
    title: "Please, confirm action!",
    open: false,
    message: "",
    onConfirm: null,
  });
  
  const confirm = (title, message, onConfirm) => {
    setConfirmState({
      title,
      open: true,
      message,
      onConfirm,
    });
  };
  
  const handleCloseConfirm = () => {
    setConfirmState({ title: "", open: false, message: "", onConfirm: null });
  };

  const students = [];
  const user = JSON.parse(localStorage.getItem("user"));

  const {
    basicActions,
    createLesson,
    editLesson,
    rescheduleLesson,
  } = useLessonActions(
    role,
    setLessons,
    selectedLesson,
    setSelectedLesson,
    mode,
    setMode,
    confirm,
    user?.isDemo,
    setChangedLesson,
  );

  const onViewEditClose = () => {
    setSelectedLesson(null);
    setMode("view");
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" keepMounted>
      <ConfirmationDialog
        title={confirmState.title}
        open={confirmState.open}
        message={confirmState.message}
        onClose={handleCloseConfirm}
        onConfirm={async () => {
          await confirmState.onConfirm?.();
          handleCloseConfirm();
          onActionPerformed();
        }}
        confirmText="Yes"
        cancelText="No"
      />
      <Box p={3}>
        <Grid2 container spacing={2} justifyContent="center">
          <Grid2>
            <ViewEditLesson
              lesson={selectedLesson}
              lessons={lessons}
              mode={mode}
              onClose={() => {
                onViewEditClose();
              }}
              onSubmit={createLesson}
              onSave={(lessonUid, lessonChanges) => {
                setChangedLesson(selectedLesson);
                editLesson(lessonUid, lessonChanges);
              }}
              onReschedule={rescheduleLesson}
              students={students}
            />
          </Grid2>
          <Grid2>
            <ActionButtonsPane
              actions={basicActions}
            />
          </Grid2>
        </Grid2>
      </Box>
    </Dialog>
  );
}
